import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivityPanel = () => {
  const recentActivities = [
    {
      id: 1,
      type: 'product_added',
      message: 'Nuevo producto agregado',
      product: 'Laptop Dell XPS 13',
      user: 'María González',
      timestamp: new Date(Date.now() - 300000), // 5 minutes ago
      icon: 'Plus',
      color: 'text-success'
    },
    {
      id: 2,
      type: 'stock_updated',
      message: 'Stock actualizado',
      product: 'iPhone 15 Pro',
      details: '50 → 75 unidades',
      user: 'Carlos Ruiz',
      timestamp: new Date(Date.now() - 900000), // 15 minutes ago
      icon: 'Package',
      color: 'text-primary'
    },
    {
      id: 3,
      type: 'price_changed',
      message: 'Precio modificado',
      product: 'Samsung Galaxy S24',
      details: '899,99€ → 849,99€',
      user: 'Ana Martín',
      timestamp: new Date(Date.now() - 1800000), // 30 minutes ago
      icon: 'DollarSign',
      color: 'text-warning'
    },
    {
      id: 4,
      type: 'product_archived',
      message: 'Producto archivado',
      product: 'iPad Air 4th Gen',
      user: 'Luis Fernández',
      timestamp: new Date(Date.now() - 3600000), // 1 hour ago
      icon: 'Archive',
      color: 'text-error'
    },
    {
      id: 5,
      type: 'sync_completed',
      message: 'Sincronización completada',
      details: '1.234 productos actualizados',
      user: 'Sistema',
      timestamp: new Date(Date.now() - 7200000), // 2 hours ago
      icon: 'RefreshCw',
      color: 'text-accent'
    }
  ];

  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (days > 0) return `hace ${days} día${days > 1 ? 's' : ''}`;
    if (hours > 0) return `hace ${hours} hora${hours > 1 ? 's' : ''}`;
    if (minutes > 0) return `hace ${minutes} min`;
    return 'hace un momento';
  };

  return (
    <div className="bg-surface rounded-lg border border-border overflow-hidden">
      {/* Header */}
      <div className="px-4 py-3 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-body-medium text-text-primary">
            Actividad Reciente
          </h3>
          <button className="text-xs text-primary hover:text-primary-700 font-body-medium">
            Ver todo
          </button>
        </div>
      </div>

      {/* Activity List */}
      <div className="max-h-96 overflow-y-auto">
        {recentActivities.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="Activity" size={32} className="text-text-muted mx-auto mb-2" />
            <p className="text-sm text-text-muted">No hay actividad reciente</p>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {recentActivities.map((activity) => (
              <div key={activity.id} className="p-4 hover:bg-secondary-50 transition-micro">
                <div className="flex items-start space-x-3">
                  {/* Icon */}
                  <div className={`mt-1 ${activity.color}`}>
                    <Icon name={activity.icon} size={16} />
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <p className="text-sm font-body-medium text-text-primary">
                        {activity.message}
                      </p>
                      <span className="text-xs text-text-muted whitespace-nowrap ml-2">
                        {getTimeAgo(activity.timestamp)}
                      </span>
                    </div>
                    
                    {activity.product && (
                      <p className="text-sm text-text-secondary mt-1">
                        {activity.product}
                      </p>
                    )}
                    
                    {activity.details && (
                      <p className="text-xs text-text-muted mt-1">
                        {activity.details}
                      </p>
                    )}
                    
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-xs text-text-muted">
                        por {activity.user}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="px-4 py-3 border-t border-border bg-secondary-50">
        <div className="flex items-center justify-center">
          <button className="text-sm text-primary hover:text-primary-700 font-body-medium flex items-center space-x-1">
            <Icon name="Clock" size={14} />
            <span>Ver historial completo</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecentActivityPanel;